import type { AssemblyMateControllerUiPort } from '@puppycad/cad-core';

/**
 * 可能承载装配体 Mate 控制器的 Viewer 运行时对象。
 */
interface AssemblyMateControllerRuntimeHost {
  /** cad-core 标准配合控制器端口。 */
  readonly assemblyMateController?: AssemblyMateControllerUiPort;
}

/**
 * 从未知渲染器对象中读取装配体 Mate 控制器端口。
 *
 * 设计说明：
 * web-client 多个入口都只需要调用 cad-core 暴露的 UI 端口。统一在工具函数中完成运行时收窄，
 * 可避免各组件重复声明 Viewer 结构，也避免把具体控制器类耦合到 UI。
 *
 * @param renderer PropertyManager 或设计树上下文传入的渲染器。
 * @returns Mate 控制器端口；未接入时返回 null。
 */
export function resolveAssemblyMateController(
  renderer: unknown,
): AssemblyMateControllerUiPort | null {
  const runtime = renderer as AssemblyMateControllerRuntimeHost | null | undefined;
  return runtime?.assemblyMateController ?? null;
}
